import APP_CONSTANTS from "src/application/shared/app_constants";
import loadCensoredWords from "../loadCensoredWords";

let censored_words_en = new Set([
  "allupato",
  "ammucchiata",
  "anale",
  "arrapato",
  "arrusa",
  "arruso",
  "assatanato",
  "bagascia",
  "bagassa",
  "bagnarsi",
  "baldracca",
  "balle",
  "battere",
  "battona",
  "belino",
  "biga",
  "bocchinara",
  "bocchino",
  "bofilo",
  "boiata",
  "bordello",
  "brinca",
  "bucaiolo",
  "budiùlo",
  "busone",
  "cacca",
  "caciocappella",
  "cadavere",
  "cagare",
  "cagata",
  "cagna",
  "casci",
  "cazzata",
  "cazzimma",
  "cazzo",
  "cesso",
  "cazzone",
  "checca",
  "chiappa",
  "chiavare",
  "chiavata",
  "ciospo",
  "ciucciami il cazzo",
  "coglione",
  "coglioni",
  "cornuto",
  "cozza",
  "culattina",
  "culattone",
  "culo",
  "ditalino",
  "fava",
  "femminuccia",
  "fica",
  "figa",
  "figlio di buona donna",
  "figlio di puttana",
  "figone",
  "finocchio",
  "fottere",
  "fottersi",
  "fracicone",
  "fregna",
  "frocio",
  "froscio",
  "goldone",
  "guardone",
  "imbecille",
  "incazzarsi",
  "incoglionirsi",
  "ingoio",
  "leccaculo",
  "lecchino",
  "lofare",
  "loffa",
  "loffare",
  "mannaggia",
  "merda",
  "merdata",
  "merdoso",
  "mignotta",
  "minchia",
  "minchione",
  "mona",
  "monta",
  "montare",
  "mussa",
  "nave scuola",
  "nerchia",
  "padulo",
  "palle",
  "palloso",
  "patacca",
  "patonza",
  "pecorina",
  "pesce",
  "picio",
  "pincare",
  "pippa",
  "pinnolone",
  "pipì",
  "pippone",
  "pirla",
  "pisciare",
  "piscio",
  "pisello",
  "pistolotto",
  "pomiciare",
  "pompa",
  "pompino",
  "porca",
  "porca madonna",
  "porca miseria",
  "porca puttana",
  "porco",
  "porco due",
  "porco zio",
  "potta",
  "puppami",
  "puttana",
  "quaglia",
  "recchione",
  "regina",
  "rincoglionire",
  "rizzarsi",
  "rompiballe",
  "rompipalle",
  "ruffiano",
  "sbattere",
  "sbattersi",
  "sborra",
  "sborrata",
  "sborrone",
  "sbrodolata",
  "scopare",
  "scopata",
  "scorreggiare",
  "sega",
  "slinguare",
  "slinguata",
  "smandrappata",
  "soccia",
  "socmel",
  "sorca",
  "spagnola",
  "spompinare",
  "sticchio",
  "stronza",
  "stronzata",
  "stronzo",
  "succhiami",
  "succhione",
  "sveltina",
  "sverginare",
  "tarzanello",
  "terrone",
  "testa di cazzo",
  "tette",
  "tirare",
  "topa",
  "troia",
  "trombare",
  "vacca",
  "vaffanculo",
  "vangare",
  "zinne",
  "zio cantante",
  "zoccola",
]);

if (!censored_words_en.keys.length) {
  async () => {
    try {
      censored_words_en = await loadCensoredWords(
        APP_CONSTANTS.CENSORED_WORDS_FETCH_URLS.IT
      );
    } catch (error) {
      throw new Error(`❌ Error loading censored words [IT]! ${error}`);
    }
  };
}

export default censored_words_en;
